export default (str, reference) => {
  /**
   * Converts between string representation of array,
   * where intermediate values are replaced with hyphen,
   * and an array where those values are filled in
   *
   * Example: "1, 3 - 5, 9" => [1, 3, 4, 5, 9]
   *
   * @param {String}  str         Values to be converted to string representation.
   * @param {Array]}  reference   What the str will be compared against to determine hyphenation.
   *                              Defaults to integer increments
   * @return {Array}              Full array of values with hyphens expanded
   */
  if (!str) return [];
  const hyphenRegex = /(\d|[a-zA-Z])(\s*[-]\s*)(\d|[-]\d|[a-zA-Z])/g;
  return str.split(/[,]\s*/g).flatMap((elem) => {
    if (elem.match(hyphenRegex)) {
      const range = elem.replace(hyphenRegex, "$1**$3").split("**");
      if (!reference)
        return Array.from(
          { length: Number(range[1]) - Number(range[0]) + 1 },
          (_, j) => j + Number(range[0]),
        );
      const indices = range.map((el) => reference.indexOf(el));
      const len =
        indices[0] < indices[1]
          ? indices[1] - indices[0] + 1
          : reference.length - indices[0] + indices[1] + 1;
      return Array.from({ length: len }, (_, j) => {
        const containedIndex = indices[0] + j;
        const wrappedIndex = j - (reference.length - indices[0]);
        return indices[0] < indices[1]
          ? reference[containedIndex]
          : reference[containedIndex < reference.length ? containedIndex : wrappedIndex];
      });
    }
    return Number.isNaN(Number(elem)) ? elem : Number(elem);
  });
};
